module.exports = __webpack_public_path__ + "f48565f2244717d739b06bf5217ed608.woff2";